import { render, staticRenderFns } from "./TechnicalFrame.vue?vue&type=template&id=33df5768&scoped=true&"
import script from "./TechnicalFrame.vue?vue&type=script&lang=js&"
export * from "./TechnicalFrame.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-manage.css?vue&type=style&index=0&id=33df5768&scoped=true&lang=css&"
import style1 from "./TechnicalFrame.vue?vue&type=style&index=1&id=33df5768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df5768",
  null
  
)

export default component.exports